export const offices = [
  {
    title: 'Headquarters',
    mobileTitle: 'Headquarters',
    items: [
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/poland.svg',
        country: 'Poland',
        city: 'Warsaw',
      },
    ],
  },
  {
    title: 'Development centers',
    mobileTitle: 'Dev. Centers',
    items: [
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/poland.svg',
        country: 'Poland',
        mobileCountry: 'PL',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Lithuania.svg',
        country: 'Lithuania',
        mobileCountry: 'LT',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/hungary.svg',
        country: 'Hungary',
        mobileCountry: 'HU',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Georgia.svg',
        country: 'Georgia',
        mobileCountry: 'GE',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/kazakhstan.svg',
        country: 'Kazakhstan',
        mobileCountry: 'KZ',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/azerbaijan.svg',
        country: 'Azerbaijan',
        mobileCountry: 'AZ',
      },
    ],
  },
  {
    title: 'Representative offices',
    mobileTitle: 'Represent. Offices',
    items: [
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/United-kingdom.svg',
        country: 'United Kingdom',
        mobileCountry: 'GB',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/United-states-of-america.svg',
        country: 'United States',
        mobileCountry: 'US',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Germany.svg',
        country: 'Germany',
        mobileCountry: 'DE',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Ireland.svg',
        country: 'Ireland',
        mobileCountry: 'IE',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Lithuania.svg',
        country: 'Lithuania',
        mobileCountry: 'LT',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Cyprus.svg',
        country: 'Cyprus',
        mobileCountry: 'CY',
      },
    ],
  },
  {
    title: 'Offices coming soon',
    mobileTitle: 'Coming Soon',
    items: [
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/UAE.svg',
        country: 'United Arab Emirates',
        mobileCountry: 'AE',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/czech-republic.svg',
        country: 'Czech Republic',
        mobileCountry: 'CZ',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/india.svg',
        country: 'India',
        mobileCountry: 'IN',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/portugal.svg',
        country: 'Portugal',
        mobileCountry: 'PT',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/romania.svg',
        country: 'Romania',
        mobileCountry: 'ROU',
      },
    ],
  },
];
